"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.success = exports.queue = exports.info = exports.failure = void 0;
var _react = _interopRequireDefault(require("react"));
var _Notification = require("../Notification");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const queue = notification => {
  return {
    state: {
      queuedNotification: notification
    }
  };
};
exports.queue = queue;
const info = (message, title) => {
  return {
    message,
    title,
    type: _Notification.NotificationSeverity.INFORMATION
  };
};
exports.info = info;
const success = (message, title) => {
  return {
    message,
    title,
    type: _Notification.NotificationSeverity.POSITIVE
  };
};
exports.success = success;
const failure = (title, error, message, actions) => {
  return {
    actions,
    message: error && error instanceof Error ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, message, " ", error.message) : message,
    title,
    type: _Notification.NotificationSeverity.NEGATIVE
  };
};
exports.failure = failure;